import React from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper';


// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';


// slider img import 
import slider1 from '../../../Assert/heroSlider/slider1.png'
import slider2 from '../../../Assert/heroSlider/slider5.png'
import slider3 from '../../../Assert/heroSlider/slider3.png'

const HeroSlider = () => {
    return (
        <div className='mt-16 pt-2  hidden md:block'>
            <Swiper
                loop={true}
                spaceBetween={30}
                pagination={{
                    clickable: true
                }}
                autoplay={{
                    delay: 1000
                }}
                modules={[Pagination, Autoplay]}
                className="mySwiper"
            >
                <SwiperSlide>
                    <img src={slider1} alt="" />
                </SwiperSlide>
                <SwiperSlide>
                    <img src={slider2} alt="" />
                </SwiperSlide>
                <SwiperSlide>
                    <img src={slider3} width={"100%"} alt="" />
                </SwiperSlide>



            </Swiper>

        </div>
    );
};

export default HeroSlider;